import styled from 'styled-components';

const shouldForwardProp = prop => !['isOpen'].includes(prop);

export const ResultQueryStyled = styled.div.withConfig({ shouldForwardProp })`
  display: flex;
  flex-direction: column;
  gap: 20px;

  .resultMessageBox {
    border-radius: 16px;
    border: 1px solid var(--GrayScale-400);
    padding: 8px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }

  .signatureSection {
    display: flex;
    gap: 8px;
    flex-direction: column;
  }

  .kakaoSignatureButton {
    justify-content: space-between;
    display: flex;
    width: 100%;
    gap: 5px;
  }

  .canvasButtonContainer {
    display: flex;
    gap: 8px;
    justify-content: flex-end;
    z-index: 1;
    position: absolute;
    width: 100%;
    right: 10px;
  }

  .canvasContainer {
    background: var(--GrayScale-100);
    padding: 10px;
    height: 250px;
    position: relative;
  }

  .resultSignPad {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }

  .SMSContainer {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .SMSTitle {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .SMSTimeBox {
    border-radius: 10px;
    background: var(--GrayScale-100);
    padding: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .kakaoStep1 {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .kakaoButton {
    width: 100%;
    position: fixed;
    bottom: 0;
    padding: 8px 16px;
    left: 0;
  }

  .kakaoStep3 {
    display: flex;
    height: 100%;
    padding: 10px 0px 40px 0px;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }

  .kakaoStep3Content {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    gap: 40px;
  }

  .kakaoMessage1 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  .kakaoMessage2 {
    border-radius: 8px;
    background: var(--GrayScale-100);
    padding: 16px;
  }

  // 인증 후
  .resultAfterBox {
    border-radius: 16px;
    border: 1px solid var(--GrayScale-300);
    background: var(--GrayScale-0);

    box-shadow: 0px 1px 10px 0px rgba(132, 132, 132, 0.15);

    display: flex;
    padding: 24px 0px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 24px;
  }

  // tabContent
  .taxResultBox {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    padding: 16px;
  }

  .tabContent {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 16px;

    border: 1px solid var(--Primary-400);

    background: var(--GrayScale-0);
  }

  .resultReport {
    position: relative;
    padding: 40px 0px 30px 0px;
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .reportItem {
    display: flex;
    padding: 16px;
    flex-direction: column;
    gap: 10px;
    border-top: 1px solid var(--GrayScale-400);
  }

  // 분납신청 모달
  .installmentOption {
    padding: 16px 0px;
    border-bottom: 1px solid var(--GrayScale-400);
  }
`;
